import React from 'react';

import type { Dispatch, SetStateAction } from 'react';

import { Minus, Plus } from '@travel/icons/ui';
import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';

import { Translate } from 'core/translate';

import styles from './showMorePlansOrRooms.module.scss';

export const DISPLAY_PLANS_ROOMS_COUNT_PC = 3;
export const DISPLAY_PLANS_ROOMS_COUNT_SP = 2;

type Props = {
  count: number;
  displayCount: number;
  rateItemRef: HTMLDivElement | null;
  setCount: Dispatch<SetStateAction<number>>;
  isShowMorePlan: boolean;
};

function ShowMorePlansOrRooms(props: Props) {
  const { count, displayCount, setCount, rateItemRef, isShowMorePlan } = props;
  const isMobile = useDeviceType() === MOBILE_SCREEN;
  const displayPlansRoomsCount = isMobile
    ? DISPLAY_PLANS_ROOMS_COUNT_SP
    : DISPLAY_PLANS_ROOMS_COUNT_PC;

  const handleClickShowMore = () => {
    setCount(count);
  };

  const handleClickShowLess = () => {
    setCount(displayPlansRoomsCount);
    if (rateItemRef) {
      rateItemRef.scrollIntoView();
    }
  };

  return displayCount === count ? (
    <div className={styles.showMoreBtn}>
      <button
        className={styles.btn}
        onClick={handleClickShowLess}
        data-testid="ratePlan-showLess-btn"
      >
        <Translate id="Traveler_Common.Show_Less" /> <Minus color="cilantro" size={14} />
      </button>
    </div>
  ) : (
    <div className={styles.showMoreBtn}>
      <button
        className={styles.btn}
        onClick={handleClickShowMore}
        data-testid="ratePlan-showMore-btn"
      >
        {isShowMorePlan ? (
          <Translate
            id="Provider_Info.Room.Show_More_Plans"
            data={{ number_of_remaining_plans: count - displayPlansRoomsCount }}
            condition={() => (count - displayPlansRoomsCount > 1 ? 'count > 1' : 'count == 1')}
          />
        ) : (
          <Translate
            id="Provider_Info.Plans.Show_More_Rooms"
            data={{ number_of_remaining_rooms: count - displayPlansRoomsCount }}
            condition={() => (count - displayPlansRoomsCount > 1 ? 'count > 1' : 'count == 1')}
          />
        )}

        <Plus color="cilantro" size={14} />
      </button>
    </div>
  );
}

export default ShowMorePlansOrRooms;
